export const FETCH_ALL_CAMPAIGN = 'FETCH_ALL_CAMPAIGN';
export const FETCH_ALL_CAMPAIGN_SUCCEED = 'FETCH_ALL_CAMPAIGN_SUCCEED';
export const FETCH_ALL_CAMPAIGN_FAILED = 'FETCH_ALL_CAMPAIGN_FAILED';

export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const ADD_CAMPAIGN_SUCCEED = 'ADD_CAMPAIGN_SUCCEED';
export const ADD_CAMPAIGN_FAILED = 'ADD_CAMPAIGN_FAILED';

export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_SUCCEED = 'UPDATE_CAMPAIGN_SUCCEED';
export const UPDATE_CAMPAIGN_FAILED = 'UPDATE_CAMPAIGN_FAILED';

export const UPDATE_CAMPAIGN_CONFIG = 'UPDATE_CAMPAIGN_CONFIG';
export const UPDATE_CAMPAIGN_CONFIG_SUCCEED = 'UPDATE_CAMPAIGN_CONFIG_SUCCEED';
export const UPDATE_CAMPAIGN_CONFIG_FAILED = 'UPDATE_CAMPAIGN_CONFIG_FAILED';

export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_SUCCEED = 'DELETE_CAMPAIGN_SUCCEED';
export const DELETE_CAMPAIGN_FAILED = 'DELETE_CAMPAIGN_FAILED';
